import {Component, OnInit, Input} from '@angular/core';
import { AbsolutePercentageModel } from '../../../../models/bar-chart/AbsolutePercentageModel';
import { MasterSummaryPDModel, MasterSummaryQuestionModel, SurveyCutQuestionModel, SurveyVersionQuestionModel } from '../../../../models/survey/survey.model';
import { PercentageType } from '../../../constants/percentage.constants';
import Utils from '../../../util/Util';

@Component({
  selector: 'app-numeric-chart',
  templateUrl: './numeric-chart.component.html',
  styleUrls: ['./numeric-chart.component.less']
})
export class NumericChartComponent implements OnInit {

  @Input() title: string;
  @Input() subTitle = '';
  @Input() averageValue: number;
  _averageDiffPercentage: number;
  @Input() averageShowPercentage: boolean;
  textToShow: string;
  @Input("surveyMasterSummaryPDModel") survMastSummPDModel: MasterSummaryPDModel;
  @Input("chartJ") chartJ: number;
  @Input("questionI") questionI: number;
  @Input("isCut") isCut: boolean;
  @Input() isCompareMode: boolean = false;
  @Input() isAllResponses: boolean;
  @Input() isSelectedAllResponses: boolean;
  typePercentage: string
  isShowDialogPercentage:boolean = false;
  myArrayPercentagePopUp = Array<AbsolutePercentageModel>();
  surveyNameMaster: string;
  

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set averageDiffPercentage(value: number){
    this._averageDiffPercentage = value;
    this.textToShow = Math.abs(this._averageDiffPercentage).toFixed(1)+'% '+(this._averageDiffPercentage < 0 ? '↓' : (this._averageDiffPercentage > 0 ? '↑' : ' '));
  }

  get averageDiffPercentage(){
    return this._averageDiffPercentage;
  }

  processClickEventAverage(){
    if(this.isCompareMode){
      if(this.survMastSummPDModel){
        let masterQuestion = this.obtainMasterChartObject();
        this.typePercentage = masterQuestion.averageTypePercentageSelected;
        if(this.typePercentage){
          let listCut = [];
          let listNoCut = [];
          let listAllResponses = [];
          let questionIndex = this.isAllResponses ? this.chartJ : this.questionI;
          this.myArrayPercentagePopUp = [];
          if(this.survMastSummPDModel.listSurveyVersionQuestion){
            if(PercentageType.RELATIVE == this.typePercentage){
              listNoCut = this.calculateAllRelative(masterQuestion,this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex,false);
            }else if(PercentageType.ABSOLUTE == this.typePercentage){
              listNoCut = this.calculateAllAbsolute(masterQuestion,this.survMastSummPDModel.listSurveyVersionQuestion,questionIndex,false);
            }
          }
          if(this.survMastSummPDModel.listSurveyCutQuestion){
            if(PercentageType.RELATIVE == this.typePercentage){
              listCut = this.calculateAllRelative(masterQuestion,this.survMastSummPDModel.listSurveyCutQuestion,questionIndex,true);
            }else if(PercentageType.ABSOLUTE == this.typePercentage){
              listCut = this.calculateAllAbsolute(masterQuestion,this.survMastSummPDModel.listSurveyCutQuestion,questionIndex,true);
            }
          }
          if(this.survMastSummPDModel.listQuestionModel && !this.isAllResponses){
            listAllResponses = this.calculateAllResponses(masterQuestion,this.survMastSummPDModel.listQuestionModel,questionIndex,this.typePercentage);
          }
          if(this.isSelectedAllResponses){
            this.myArrayPercentagePopUp = [ ...listAllResponses, ...listNoCut, ...listCut];
          }else{
            this.myArrayPercentagePopUp = [ ...listNoCut, ...listCut];
          }
          this.showPercentageDialog();
        }
      }
    }
  }

  private obtainMasterChartObject(): MasterSummaryQuestionModel{
    if(this.isAllResponses){
      this.surveyNameMaster = 'ALL RESPONSES';
      return this.survMastSummPDModel.listQuestionModel[this.chartJ];
    }else{
      if(!this.isCut){
        this.surveyNameMaster = this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].surveyName;
        return this.survMastSummPDModel.listSurveyVersionQuestion[this.chartJ].listQuestionModel[this.questionI];
      }else{
        this.surveyNameMaster = this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].surveyName;
        return this.survMastSummPDModel.listSurveyCutQuestion[this.chartJ].listQuestionModel[this.questionI];
      }
    }
  }

  //This function will iterate over all chart and it will call the function to calculate the relative percentage difference
  private calculateAllRelative(masterQuestion: MasterSummaryQuestionModel,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number,isCutList:boolean){
    let i: number;
    let result = [];
    for(i=0;i<listQuestion.length;i++){
      if(this.isAllResponses){
        let percentage = this.calculateRelative(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
        if(!isNaN(percentage)){
          result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
        }
      }else{
        if(i != this.chartJ){
          let percentage = this.calculateRelative(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
          if(!isNaN(percentage)){
            result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
          }
        }else{
          if(i == this.chartJ && isCutList && !this.isCut){
            let percentage = this.calculateRelative(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
            if(!isNaN(percentage)){
              result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
            }
          }else if(i == this.chartJ && !isCutList && this.isCut){
            let percentage = this.calculateRelative(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
            if(!isNaN(percentage)){
              result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
            }
          }
        }
      }
    }
    return result;
  }
  
  //This function will iterate over all chart and it will call the function to calculate the relative percentage difference
  private calculateAllAbsolute(masterQuestion: MasterSummaryQuestionModel,listQuestion: SurveyVersionQuestionModel[] | SurveyCutQuestionModel[],questionIndex: number,isCutList:boolean){
    let i: number;
    let result = [];
    for(i=0;i<listQuestion.length;i++){
      if(this.isAllResponses){
        let percentage = this.calculateAbsolute(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
        if(!isNaN(percentage)){
          result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
        }
      }else{
        if(i != this.chartJ){
          let percentage = this.calculateAbsolute(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
          if(!isNaN(percentage)){
            result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
          }
        }else{
          if(i == this.chartJ && isCutList && !this.isCut){
            let percentage = this.calculateAbsolute(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
            if(!isNaN(percentage)){
              result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
            }
          }else if(i == this.chartJ && !isCutList && this.isCut){
            let percentage = this.calculateAbsolute(masterQuestion,listQuestion[i].listQuestionModel[questionIndex]);
            if(!isNaN(percentage)){
              result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),listQuestion[i].surveyName));
            }
          }
        }
      }
    }
    return result;
  }

  //This function will apply this formula ((PercentageMaster - PercentageSibling)/PercentageSibling)*100 to the sibling response sent as parameter
  private calculateRelative(masterResponse: MasterSummaryQuestionModel,siblingResponse: MasterSummaryQuestionModel): number{
    if(masterResponse && siblingResponse){
        let diffPercentage = 0.0;
        let basePercentage = siblingResponse.averageValue;
        let numerator = masterResponse.averageValue - basePercentage;
        if(basePercentage != 0){
          diffPercentage = (numerator/basePercentage)*100;
        }else if(basePercentage == 0 && numerator != 0){
          return NaN;
        }
        return Utils.roundNumber(diffPercentage,1);
    }
    return 0;
  }

  //This function will apply this formula PercentageMaster - PercentageSibling to the sibling response sent as parameter
  private calculateAbsolute(masterResponse: MasterSummaryQuestionModel,siblingResponse: MasterSummaryQuestionModel): number{
    if(masterResponse && siblingResponse){
        let diffPercentage = 0.0;
        let basePercentage = siblingResponse.averageValue;
        diffPercentage = masterResponse.averageValue - basePercentage;
        return Utils.roundNumber(diffPercentage,1);
    }
    return 0;
  }

  private calculateAllResponses(masterQuestion: MasterSummaryQuestionModel,listQuestions:MasterSummaryQuestionModel[],questionIndex:number,percentageType:string){
    let result = [];
    if(PercentageType.RELATIVE == percentageType){
      let percentage = this.calculateRelative(masterQuestion,listQuestions[questionIndex]);
      if(!isNaN(percentage)){
        result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),'ALL RESPONSES'));
      }
    }else if(PercentageType.ABSOLUTE == this.typePercentage){
      let percentage = this.calculateAbsolute(masterQuestion,listQuestions[questionIndex]);
      if(!isNaN(percentage)){
        result.push(this.createObject(null,percentage,this.getDescriptionByPercentage(percentage),'ALL RESPONSES'));
      }
    }
    return result;
  }

  //This function will return Lower if the parameter is lower than 0 or Greater or equal in other cases
  private getDescriptionByPercentage(percentage: number): string{
    let result = "the same as";
    if(percentage > 0){
      result = "higher"
    }else if(percentage < 0){
      result = "lower";
    }
    return result;
  }

  private showPercentageDialog(){
    this.isShowDialogPercentage = true;
  }

  hidePercentageDialog() {
    this.isShowDialogPercentage = false;
  }

  private createObject(id:number,percentage:number,percDesc:string,survName:string): AbsolutePercentageModel{
    return {
      id: id,
      diffPercentage: Math.abs(percentage),
      percDesc: percDesc,
      survName: survName
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/chart/numeric-chart/numeric-chart.component.ts